import React from 'react';
import ReactDOM from 'react-dom';
import TextCell from './TextCell';
import SortHeaderCell from './SortHeaderCell';
import { Table, Column, Cell } from 'fixed-data-table';
import * as actions from '../redux/actions';
import DataTableUtil from '../DataTableUtil';
import Storage from '../Storage';
import { SortTypes } from '../Constants';
import BaseLayout from './pages/BaseLayout';
import { browserHistory } from 'react-router';
import Util from '../Util';

const DEFAULT_COL_SORT_DIRS = { datecreated: SortTypes.DESC };
const DEFAULT_TABLE_WIDTH = 1276;
const DEFAULT_TABLE_HEIGHT = 500;

function getFilterKey(tableTitle, tableView) {
  return tableTitle + '-' + tableView + '-filterText';
}

function getColSortKey(tableTitle, tableView) {
  return tableTitle + '-' + tableView + '-columnSortDirs';
}

function getTableViewKey() {
  return 'BatchActionsHistoryTable : tableView';
}

function getStateObjectKey(tableTitle, keyName) {
  return tableTitle + '-' + keyName;
}

const LIST_VIEW = 'list';

const FILTER_COLUMNS = {
  [LIST_VIEW]: [
    'kioskid', 'actionname', 'kioskname', 'kiosktype',
    'ipaddr', 'locationname', 'orgname', 'responsecode',
    'datecreated', 'responsedata'
  ],
};

class BatchActionsHistoryTable extends React.Component {
  constructor(props) {
    super(props);

    let showMoreFilters =
      Storage.getSessionItem(getStateObjectKey(props.tableTitle, 'showMoreFilters')) || false;
    let tableView = Storage.getSessionItem(getTableViewKey()) || LIST_VIEW;
    let filterText = Storage.getSessionItem(getFilterKey(props.tableTitle, tableView)) || '';
    let columnSortDirs =
      Storage.getSessionItem(getColSortKey(props.tableTitle, tableView)) || DEFAULT_COL_SORT_DIRS;

    this.state = {
      tableView: tableView,
      filterText: filterText,
      showMoreFilters: showMoreFilters,
      columnSortDirs: columnSortDirs,
    };

    this.handleSortChange = this.handleSortChange.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.filterAction = this.filterAction.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleToggleBooleanState = this.handleToggleBooleanState.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(actions.getQueueActionLog());
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  handleSortChange(columnKey, sortDir) {
    let value = { [columnKey]: sortDir };
    this.setState({ columnSortDirs: value }, () => {
      Storage.setSessionItem(getColSortKey(this.props.tableTitle, this.state.tableView), value);
    });
  }

  handleFilter(e) {
    if (!e.target.value) {
      this.setState({ filterText: '' }, () => {
        Storage.setSessionItem(getFilterKey(this.props.tableTitle, this.state.tableView), '');
      });
      return;
    }

    const filterBy = this.refs.filterInput.value.toLowerCase();
    this.setState({ filterText: filterBy }, () => {
      Storage.setSessionItem(getFilterKey(this.props.tableTitle, this.state.tableView), filterBy);
    });
  }

  getDistinctActions(queueActionLog) {
    let set = new Set();
    for (let i = 0; i < queueActionLog.length; i++) {
      set.add(queueActionLog[i].actionname);
    }
    return ['All', ...set];
  }

  cleanUpTime(queueActionLog) {
    for (let i = 0; i < queueActionLog.length; i++) {
      queueActionLog.datecreated = Util.localDateTimeString(queueActionLog.datecreated);
    }
    return queueActionLog;
  }

  filterAction(e) {
    if (!e.target.value || e.target.value == 'All') {
      this.setState({ filterText: '' }, () => {
        Storage.setSessionItem(getFilterKey(this.props.tableTitle, this.state.tableView), '');
      });
      return;
    }

    const filterBy = e.target.value;
    this.setState({ filterText: e.target.value }, () => {
      Storage.setSessionItem(getFilterKey(this.props.tableTitle, this.state.tableView), filterBy);
    });
  }

  handleToggleBooleanState(name) {
    let value = this.state[name];
    this.setState({ [name]: !value }, () => {
      Storage.setSessionItem(getStateObjectKey(this.props.tableTitle, name), !value);
    });
  }

  handleRowClick(dataList, event, rowIndex) {
    let name = dataList[rowIndex].name;
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    //console.log('handleInputChange', name, value);

    if (name.indexOf('.') !== -1) {
      let objName = name.split(/\./)[0];
      let keyName = name.split(/\./)[1];
      let obj = { ...this.state[objName] };
      obj[keyName] = value;
      this.setState(
        {
          [objName]: obj,
        },
        () => {
          Storage.setSessionItem(getStateObjectKey(this.props.tableTitle, objName), obj);
        }
      );
    } else {
      this.setState(
        {
          [name]: value,
        },
        () => {
          Storage.setSessionItem(getStateObjectKey(this.props.tableTitle, name), value);
        }
      );
    }
  }

  render() {
    const { filterText, columnSortDirs, tableView, showMoreFilters } = this.state;
    let queueActionLog = this.props.queueActionLog || [];

    let actions = this.getDistinctActions(queueActionLog);
    let queueList = this.cleanUpTime(queueActionLog);
    const dataList = DataTableUtil.filterList(
      queueList,
      filterText,
      FILTER_COLUMNS[tableView],
      columnSortDirs
    );
    const size = dataList.length;

    // console.log(this.props.tableTitle + ' render: ' + new Date().toLocaleString());
    let tableWidth = this.props.tableWidth || DEFAULT_TABLE_WIDTH;
    let tableHeight = BaseLayout.calcTableHeight(dataList) || DEFAULT_TABLE_HEIGHT;

    let {
      auth: { user },
    } = this.props;
    let isSuper = user.isSuperRole();

    return (
      <div>
        <div style={{ display: 'block', margin: '20px auto', width: tableWidth }}>
          <div style={{ textAlign: 'right', marginTop: '-20px', marginBottom: '3px' }}>
            <a
              href='javascript:void(0)'
              onClick={this.handleToggleBooleanState.bind(this, 'showMoreFilters')}
            >
              More Filters:
            </a>
            <input
              style={{ marginLeft: '5px' }}
              name='showMoreFilters'
              type='checkbox'
              checked={showMoreFilters}
              onChange={this.handleInputChange}
            />
          </div>
          <div className='pure-g pure-u-1 card-label button-tetriary'>
            <i className='fa fa-fw fa-desktop' />
            {this.props.tableTitle}
            <input
              className='table-search'
              type='search'
              placeholder='Search'
              ref='filterInput'
              value={filterText}
              onChange={this.handleFilter}
            />
          </div>

          {showMoreFilters && (
            <div className='pure-g pure-u-1 card-sub-label' style={{ opacity: 1 }}>
              <select
                style={{ opacity: 1 }}
                className='select-filter'
                name='selectedFilterObj.orgName'
                onChange={this.filterAction}
              >
                {actions.map((action) => (
                  <option key={action} value={action}>
                    {action}
                  </option>
                ))}
              </select>
            </div>
          )}

          <Table
            rowsCount={dataList.length}
            rowHeight={50}
            headerHeight={50}
            width={tableWidth}
            height={tableHeight}
            onRowClick={this.handleRowClick.bind(this, dataList)}
            {...this.props}
          >
            <Column
              header={<Cell>#</Cell>}
              cell={(props) => (
                <Cell {...props}>
                  <span style={{ fontSize: 10 }}>{props.rowIndex + 1}</span>
                </Cell>
              )}
              fixed={true}
              width={46}
              align='center'
            />
            <Column
              columnKey='kioskid'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.kioskid}
                >
                  Kiosk ID
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='kioskid' />}
              fixed={true}
              width={240}
            />
            <Column
              columnKey='actionname'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.actionname}
                >
                  Action Name
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='actionname' />}
              fixed={true}
              width={120}
            />
            <Column
              columnKey='kioskname'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.kioskname}
                >
                  Kiosk Name
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='kioskname' />}
              fixed={true}
              width={90}
            />
            <Column
              columnKey='kiosktype'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.kiosktype}
                >
                  Kiosk Type
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='kiosktype' />}
              fixed={true}
              width={60}
            />
            <Column
              columnKey='ipaddr'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.ipaddr}
                >
                  IP Address
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='ipaddr' />}
              fixed={true}
              width={100}
            />
            <Column
              columnKey='locationname'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.locationname}
                >
                  Location
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='locationname' />}
              fixed={true}
              width={100}
            />
            <Column
              columnKey='orgname'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.orgname}
                >
                  Org
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='orgname' />}
              fixed={true}
              width={100}
            />
            <Column
              columnKey='responsecode'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.responsecode}
                >
                  Response Code
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='responsecode' />}
              fixed={true}
              width={80}
            />
            <Column
              columnKey='datecreated'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.datecreated}
                >
                  Date Created
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='datecreated' />}
              fixed={true}
              width={120}
            />
            <Column
              columnKey='responsedata'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.responsedata}
                >
                  ResponseData
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='responsedata' />}
              fixed={true}
              width={220}
            />
          </Table>
          <div className='pure-g' style={{ padding: '5px 0' }}>
            <div className='pure-u-1-3'>
              {dataList.length < size ? (
                <span>
                  Showing {dataList.length} entries (filtered from {size} total entries)
                </span>
              ) : (
                <span>
                  Showing {dataList.length} of {size}
                </span>
              )}
            </div>
            <div className='pure-u-1-3'></div>
            <div className='pure-u-1-3' style={{ textAlign: 'right' }}></div>
          </div>
        </div>
      </div>
    );
  }
}

export default BatchActionsHistoryTable;



// WEBPACK FOOTER //
// ./src/components/BatchActionHistoryTable.js